import { WarningOutlined } from "@ant-design/icons";
import cx from "classnames";
import { useField } from "formik";
import { useEffect, useState } from "react";

import styles from "../Input/Input.module.css";
import myStyles from "./InputNumber.module.css";
// import "./InputNumber.module.fix.css";
import { InputNumber as AntInputNumber, ConfigProvider } from "antd/lib";
import { useTranslation } from "react-i18next";

const InputNumber = ({
  label = "",
  name = "",
  placeholder = "",
  type = "text",
  size = "middle",
  min = null,
  precision = null,
  max = null,
  prefix = null,
  suffix = null,
  onChange = () => { },
  className = "",
  required = false,
  disabled = false,
  useTimeout = null,
  step = 1,
  stringMode = false,
  parser = null,
  formatter = null,
  controls = true,
  readOnly = false,
  variant = "outlined", //["outlined", "borderless", "filled"]
  textAlign = "",
  defaultValue = "",
  onKeyDown = () => { }
}) => {
  const { i18n } = useTranslation();
  const [timeoutId, setTimeoutId] = useState(null);
  const [field, meta, helpers] = useField(name);
  const { onBlur } = field;
  const { value, error, touched } = meta;
  const { setValue } = helpers;

  const handleChange = (val) => {
    setValue(val);
    if (useTimeout) {
      if (timeoutId) clearTimeout(timeoutId);
      setTimeoutId(
        setTimeout(() => {
          onChange(val);
        }, useTimeout)
      );
    } else {
      onChange(val);
    }
  };

  const translatedError =
    touched && error
      ? i18n.language === "th"
        ? `กรุณากรอก ${label}`
        : `Please enter ${label.toLowerCase()}`
      : "";

  useEffect(() => {
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  return (
    <div className={cx(styles.container, className)}>
      {label && (
        <label className={cx("label", styles.label)} htmlFor={name}>
          {label}
          {required && <span className="error">*</span>}
        </label>
      )}
      <ConfigProvider theme={{
        components: {
          InputNumber: {
            handleVisible: true,
            // handleFontSize: 0,
            // handleWidth: 0
          }
        }
      }}>
        <AntInputNumber
          readOnly={readOnly}
          variant={variant}
          style={{ textAlignLast: textAlign }}
          id={name}
          className={myStyles.input}
          name={name}
          placeholder={placeholder}
          type={type}
          value={value}
          min={min}
          max={max}
          addonBefore={prefix}
          precision={precision}
          // prefix={prefix}
          // suffix={suffix}
          addonAfter={suffix}
          onChange={handleChange}
          onBlur={onBlur}
          data-state={touched && error ? "error" : ""}
          status={touched && error ? "error" : ""}
          disabled={disabled}
          data-type={type}
          size={size}
          step={step}
          stringMode={stringMode}
          {...parser === true ? {} : { parser: parser }}
          {...formatter === true ? {} : { formatter: formatter }}
          // parser={parser == true ? ({}) : parser}
          controls={controls}
          defaultValue={defaultValue}
          onKeyDown={onKeyDown}
        />
      </ConfigProvider>
      {translatedError && (
        <span className={cx("error", styles.error)}>
          <WarningOutlined /> {translatedError}
        </span>
      )}
    </div>
  );
};

export default InputNumber;
